import { Component } from '@angular/core';
import { ContactIntakeComponent } from '../shared/contact-intake/contact-intake.component';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
  imports: [ContactIntakeComponent],
})
export class MessageComponent {}
